// extracted by mini-css-extract-plugin
export var active = "_2l-9";
export var backButton = "_2l-8";
export var clone = "_2l-e";
export var collapseBar = "_2l-j";
export var collapseMode = "_2l-l";
export var collapsed = "_2l-n";
export var dragHandle = "_2l-c";
export var dropdownIcon = "_2l-g";
export var expanding = "_2l-m";
export var hidden = "_2l-w";
export var iconContainer = "_2l-p";
export var iconSwapper = "_2l-v";
export var navItem = "_2l-6";
export var navItemIcon = "_2l-f";
export var navProfile = "_2l-7";
export var notificationCountBadge = "_2l-i";
export var notificationDot = "_2l-q";
export var optionsContainer = "_2l-h";
export var primaryNav = "_2l-0";
export var primaryNavDivider = "_2l-u";
export var primaryNavResizeHandle = "_2l-2";
export var primaryNavResizing = "_2l-1";
export var primaryNavTabSection = "_2l-t";
export var primaryTab = "_2l-o";
export var primaryTabIconBox = "_2l-r";
export var secondaryNav = "_2l-3";
export var selected = "_2l-s";
export var settingsNav = "_2l-4";
export var settingsNavItems = "_2l-5";
export var show = "_2l-d";
export var sideNav = "_2l-k";
export var teamItem = "_2l-a";
export var userProfileItem = "_2l-b";